import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import Swal from 'sweetalert2'
import { ClienteModulo } from "../types/Clientes";
import { URLS } from "../../../infra/URLS";
import { api } from "../../../infra/api";

export default function usePostCliente(onSuccess: () => void, isLoading: () => void) {
  return useMutation((value : ClienteModulo) => 
    api
      .post(URLS.CLIENTES_API, value)
      .then((response : any) => {
        console.log(response);
        Swal.fire({
          title: "Cliente Cadastrado",
          text: "O cliente foi cadastrado com sucesso!",
          icon: "success",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#349946",
          allowOutsideClick: false
        }).then(() => {
          onSuccess();
          queryClient.invalidateQueries();
        });
      })
      .catch((err : any) => {
        console.log(err);
        isLoading();
        err.response.status === 500 ?
          Swal.fire({
            title: `Erro de status ${err.response.status}`,
            text: `Ocorreu um erro interno ao cadastrar o cliente. Por favor, entre em contato com um administrador do sistema.`,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          })
        :
          Swal.fire({
            title: "Erro ao cadastrar o cliente",
            text: err.response.data.message,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          });
        }
      )
  )
}